<template>
  <main-layout>

    <!-- Header moderno -->
    <PageHeader icon="ri-book-open-line" title="Mis Clases Programadas" :subtitle="headerSubtitle" :show-button="true"
      button-text="Actualizar" button-icon="ri-loop-right-line" @action="actualizar" />

    <div class="content-container">

      <!-- Sección Colapsable de Clases Programadas -->
      <div class="classes-collapsible-section">
        <div class="collapsible-header" @click="showClasesCollapsible = !showClasesCollapsible">
          <div class="collapsible-title">
            <i class="ri-book-open-line"></i>
            <h3>Mis Clases Programadas</h3>
            <span v-if="clases && clases.length > 0" class="badge-count">{{ clases.length }}</span>
          </div>
          <button class="btn-toggle" :class="{ 'expanded': showClasesCollapsible }">
            <i class="ri-arrow-down-s-line"></i>
          </button>
        </div>
        <transition name="collapse">
          <div v-show="showClasesCollapsible" class="collapsible-content">
            <!-- Mensaje cuando no hay clases -->
            <div v-if="!clases || clases.length === 0" class="empty-state">
              <i class="ri-calendar-2-line"></i>
              <p>No tienes clases programadas en este momento</p>
              <span class="empty-subtitle">Programa una nueva clase o consulta tu histórico</span>
            </div>

            <!-- Lista de clases -->
            <div v-else class="classes-list">
              <ClaseProgramada v-for="(agendamiento, index) in clases" :key="index"
                :agendamiento="agendamiento" />
            </div>

            <button class="btn-historic" @click="cargarHistorico">
              <i class="ri-time-line"></i>
              Ver histórico
            </button>
          </div>
        </transition>
      </div>

      <!-- Botón para programar nueva clase -->
      <div class="action-card" @click="$router.push('/programar')">
        <div class="action-icon">
          <i class="ri-calendar-line"></i>
        </div>
        <div class="action-content">
          <h3>Programar Nueva Clase</h3>
          <p>Agenda tu próxima sesión</p>
        </div>
        <i class="ri-arrow-right-line action-arrow"></i>
      </div>

      <!-- Encuesta Modal -->
      <EncuestaClase v-if="encuestaMostrar" :agendamiento="agendamientoEncuesta" @cerrar="actualizarEncuesta"
        :mostrar="encuestaMostrar" />
    </div>

  </main-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ClaseProgramada from '@/features/clases/components/ClaseProgramada';
import EncuestaClase from '@/features/clases/components/EncuestaClase';
import MainLayout from '@/components/Layout/MainLayout.vue';
import PageHeader from '@/components/Layout/PageHeader.vue';

export default {
  name: 'MisClasesPage',
  components: {
    ClaseProgramada,
    EncuestaClase,
    MainLayout,
    PageHeader
  },
  data() {
    return {
      agendamientoEncuesta: null,
      agendamientoPrueba: {
        id: 'prueba',
        sede: { nombre: 'Sede de prueba' },
        hora: '10:00 AM',
        clase: {
          profesor: {
            primer_nombre: 'Docente',
            primer_apellido: 'de prueba'
          }
        }
      },
      encuestas: null,
      showClasesCollapsible: true,
      isRefreshing: false
    }
  },
  mounted() {
    this.actualizar();
  },
  methods: {
    ...mapActions({
      fetchClases: 'academico/fetchClases',
      fetchEncuestas: 'academico/fetchEncuestas'
    }),
    actualizar() {
      this.isRefreshing = true;
      this.fetchClases();
      this.encuesta();
      setTimeout(() => {
        this.isRefreshing = false;
      }, 1000);
    },
    cargarHistorico() {
      this.fetchClases({ history: true }).then(() => { })
    },
    encuesta() {
      this.fetchEncuestas().then((result) => {
        this.encuestas = result;
        if (this.encuestas && this.encuestas.length) {
          this.agendamientoEncuesta = this.encuestas[0];
        }
      })
    },
    actualizarEncuesta() {
      this.agendamientoEncuesta = null;
      this.actualizar();
    }
  },
  computed: {
    ...mapState({
      clases: state => state.academico.clases,
      ultima_actualizacion: state => state.academico.ultima_actualizacion
    }),
    headerSubtitle() {
      if (this.lastTime) {
        return `Última actualización: ${this.lastTime} ${this.zonaRegional}`;
      }
      return 'Gestiona tus clases programadas';
    },
    lastTime() {
      if (this.ultima_actualizacion) {
        return this.ultima_actualizacion.toLocaleString()
      }
      return null
    },
    zonaRegional() {
      return `(${this.userTimeZone})`;
    },
    encuestaMostrar() {
      if (this.agendamientoEncuesta && this.agendamientoEncuesta.clase) {
        if (this.agendamientoEncuesta.showEncuesta) {
          return true;
        }
      }
      return false;
    },
    userTimeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
  }
}
</script>

<style scoped>
.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Sección Colapsable de Clases Programadas */
.classes-collapsible-section {
  position: relative;
  z-index: 1;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--theme-shadow-md);
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.collapsible-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--theme-bg-card);
}

.collapsible-header:hover {
  background: var(--theme-hover-bg-light);
}

.collapsible-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--theme-text-primary);
}

.collapsible-title svg {
  color: var(--app-color-cyan-light);
  font-size: 1.5rem;
}

.collapsible-title h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 0.5rem;
  background: var(--theme-gradient-success);
  color: white;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 242, 254, 0.3);
}

.btn-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 8px;
  color: var(--theme-text-secondary);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-toggle:hover {
  background: var(--theme-hover-bg);
  color: var(--theme-text-primary);
}

.btn-toggle svg {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-toggle.expanded svg {
  transform: rotate(180deg);
}

.collapsible-content {
  padding: 0 2rem 2rem;
  border-top: 1px solid var(--theme-border-color);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  gap: 0.75rem;
}

.empty-state svg {
  font-size: 3.5rem;
  color: var(--theme-text-secondary);
  opacity: 0.5;
  margin-bottom: 0.5rem;
}

.empty-state p {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--theme-text-primary);
  margin: 0;
}

.empty-subtitle {
  font-size: 0.9rem;
  color: var(--theme-text-secondary);
  font-weight: 500;
}

.classes-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.btn-historic {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 10px;
  color: var(--theme-text-secondary);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 1rem;
}

.btn-historic:hover {
  background: var(--theme-hover-bg);
  color: var(--theme-text-primary);
  transform: translateY(-2px);
}

/* Collapse Transition */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 1000px;
  overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

/* Action Card */
.action-card {
  position: relative;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 20px;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.6s ease-out 0.3s both;
  overflow: hidden;
}

.action-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--theme-gradient-primary);
  transition: width 0.3s ease;
}

.action-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--theme-shadow-lg);
  border-color: var(--theme-border-color-strong);
}

.action-card:hover::before {
  width: 8px;
}

.action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: var(--theme-gradient-primary);
  border-radius: 16px;
  color: white;
  font-size: 1.75rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.action-card:hover .action-icon {
  transform: scale(1.1) rotate(5deg);
}

.action-content {
  flex: 1;
}

.action-content h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--theme-text-primary);
}

.action-content p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--theme-text-secondary);
}

.action-arrow {
  font-size: 1.5rem;
  color: var(--theme-text-secondary);
  transition: all 0.3s ease;
}

.action-card:hover .action-arrow {
  transform: translateX(5px);
  color: var(--theme-text-primary);
}

/* Responsive */
@media (max-width: 768px) {
  .content-container {
    padding: 1.5rem;
  }

  .collapsible-header {
    padding: 1.25rem 1.5rem;
  }

  .collapsible-title {
    font-size: 1.1rem;
    gap: 0.5rem;
  }

  .collapsible-title h3 {
    font-size: 1.1rem;
  }

  .collapsible-content {
    padding: 0 1.5rem 1.5rem;
  }

  .empty-state {
    padding: 2.5rem 1.5rem;
  }

  .empty-state svg {
    font-size: 3rem;
  }

  .empty-state p {
    font-size: 1rem;
  }

  .empty-subtitle {
    font-size: 0.85rem;
  }

  .classes-list {
    gap: 0.875rem;
    margin-top: 1.25rem;
  }

  .action-card {
    padding: 1.5rem;
  }

  .action-icon {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .action-content h3 {
    font-size: 1.1rem;
  }

  .action-content p {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 1rem;
  }

  .collapsible-header {
    padding: 1rem 1.25rem;
  }

  .collapsible-title {
    font-size: 1rem;
    gap: 0.5rem;
  }

  .collapsible-title h3 {
    font-size: 1rem;
  }

  .collapsible-title svg {
    font-size: 1.25rem;
  }

  .btn-toggle {
    width: 32px;
    height: 32px;
  }

  .btn-toggle svg {
    width: 18px;
    height: 18px;
  }

  .collapsible-content {
    padding: 0 1.25rem 1.25rem;
  }

  .empty-state {
    padding: 2rem 1rem;
  }

  .empty-state svg {
    font-size: 2.5rem;
  }

  .empty-state p {
    font-size: 0.95rem;
  }

  .empty-subtitle {
    font-size: 0.8rem;
  }

  .classes-list {
    gap: 0.75rem;
    margin-top: 1rem;
  }

  .btn-historic {
    padding: 0.625rem 1.25rem;
    font-size: 0.875rem;
  }

  .action-card {
    padding: 1.25rem;
    gap: 1rem;
  }

  .action-icon {
    width: 45px;
    height: 45px;
    font-size: 1.35rem;
  }

  .action-content h3 {
    font-size: 1rem;
  }

  .action-content p {
    font-size: 0.8rem;
  }

  .action-arrow {
    font-size: 1.25rem;
  }
}
</style>
